import clickOutside from 'click-outside'

export default megaMenu = (options) => {
  const { container } = options
  const headerEl = document.getElementById(container)
  const navEl = document.getElementById('js-nav-primary')
  const mobileBtnEl = document.getElementById('js-mobile-nav-open')
  const mobileCloseBtnEl = document.getElementById('js-mobile-nav-close')
  const overlayEl = document.getElementById('js-site-overlay')
  const panelActiveClass = 'nav-panel--active'
  let currentMenuItem = null
  let currentMenuPanel = null

  if (!headerEl) return

  // render submenu items
  subMenu()

  const handleOutsideClick = (target, panel) => {
    panel.classList.remove('nav-panel--active')
  }

  const panelVisible = (menuItem, panel) => {
    // TODO: active class
    if (menuItem) {
      currentMenuItem = menuItem
    }

    // Remove currently opened panels
    const allPanels = document.querySelectorAll('[data-menu-panel]')
    allPanels?.length &&
      allPanels.forEach((panel) => panel.classList.remove(panelActiveClass))

    // Open selected panel
    if (panel) {
      panel.classList.add(panelActiveClass)
      clickOutside(panel, (event) => {
        if (
          event.target.nodeName !== 'A' &&
          event.target.nodeName !== 'BUTTON'
        ) {
          handleOutsideClick(event, panel)
        }
      })

      currentMenuPanel = panel
    }
  }

  const panelHidden = (menuItem, panel) => {
    if (menuItem) {
      currentMenuItem = null
    }

    if (panel) {
      panel.classList.remove(panelActiveClass)
      currentMenuPanel = null
    }
  }

  const mobileNavVisible = () => {
    navEl.classList.add('nav-primary--active')
    document.body.classList.add('nav-primary--body-active')
    overlayEl.classList.remove('invisible')

    clickOutside(
      navEl,
      (event) => event.target.nodeName !== 'BUTTON' && mobileNavHidden(),
    )
  }

  const mobileNavHidden = () => {
    navEl.classList.remove('nav-primary--active')
    document.body.classList.remove('nav-primary--body-active')
    overlayEl.classList.add('invisible')
  }

  // click actions
  headerEl.addEventListener('click', (e) => {
    const menuItem = e?.target
    const menuItemID = menuItem?.dataset?.menuItem
    const panel = document.querySelector(`[data-menu-panel="${menuItemID}"]`)

    if (!menuItemID) return

    e.preventDefault()

    if (panel && panel.classList.contains('nav-panel--active')) {
      return panelHidden(menuItem, panel)
    }

    return panelVisible(menuItem, panel)
  })

  mobileBtnEl.addEventListener('click', () => mobileNavVisible())
  mobileCloseBtnEl.addEventListener('click', () => mobileNavHidden())

  // key actions
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (currentMenuPanel && currentMenuItem) {
        panelHidden(currentMenuItem, currentMenuPanel)
      }
      mobileNavHidden()
    }
  })
}

const subMenu = () => {
  const items = document.querySelectorAll('[data-menu-level="3"]')

  if (!items?.length) return

  items.forEach((item) => {
    if (item?.parentNode?.nodeName === 'LI') {
      item.parentNode.classList.add('menu-item-has-children')
    }
  })

  const childItems = document.querySelectorAll('.menu-item-has-children')

  if (!childItems?.length) return

  childItems.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (
        e.target.classList.contains('menu-item-has-children') ||
        e.target.parentElement?.classList.contains('menu-item-has-children')
      ) {
        e.preventDefault()
      }

      if (e.target?.nextElementSibling?.nodeName === 'UL') {
        e.target.nextElementSibling.classList.toggle('hidden')
      }
    })
  })
}
